import React from 'react';

import Dialog from 'carbon-react/lib/components/dialog';

import { FormattedMessage, useIntl } from '@futrli/localisation';
import { UISystemIcon } from '@futrli/ui-components';

import * as styles from './email-preview.scss';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  emailSubject: string;
  emailBody: string;
}

export const EmailPreview = ({ isOpen, handleClose, emailSubject, emailBody }: Props) => {
  const intl = useIntl();

  return (
    <Dialog
      open={isOpen}
      onCancel={handleClose}
      aria-label={intl.formatMessage({
        id: 'common.email_preview_dialog.aria_label',
        defaultMessage: 'Email preview dialog'
      })}
      size="auto"
      greyBackground
      className={styles.carbonCloseIcon}
      contentPadding={{
        p: 0
      }}
    >
      <div className={styles.emailPreviewDialogContainer}>
        <div className={styles.titleContainer}>
          <UISystemIcon iconName="white-by-sage-logo" width={120} height={55} />
        </div>
        <div className={styles.content}>
          <div className={styles.title} style={{ marginBottom: 24 }}>
            {emailSubject}
          </div>
          <div className={styles.bodyContent} style={{ marginBottom: 24 }}>
            {emailBody}
          </div>
        </div>
        <div className={styles.footerContainer}>
          <div style={{ marginBottom: 30 }}>
            <UISystemIcon iconName="facebook-icon" width={25} height={25} />
            <UISystemIcon iconName="instagram-icon" width={25} height={25} />
            <UISystemIcon iconName="linkedin-icon" width={25} height={25} />
            <UISystemIcon iconName="twitter-icon" width={25} height={25} />
            <UISystemIcon iconName="youtube-icon" width={25} height={25} />
          </div>
          <div className={styles.dividerBar} />
          <div className={styles.futrliMessage} style={{ marginTop: 16 }}>
            <FormattedMessage
              id="common.futrli_sage_info"
              defaultMessage="Sage (UK) Limited C23 5 & 6 Cobalt Park Way, Cobalt Business Park, Newcastle-upon-Tyne, Tyne & Wear, NE28 9EJ, United Kingdom VAT number: GB121084165"
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
